export default "__VITE_ASSET__D9FUzKkY__"